import { useQuery } from '@tanstack/react-query';
import { getStorefrontSettings } from '../../api/apiSettings';

/**
 * Loads the public storefront settings. Cached for an hour because
 * these values change infrequently. Used to gate guest checkout on
 * `settings.checkout.allow_guest`.
 */
export const useGetStorefrontSettings = () => {
    const { data, isLoading } = useQuery({
        queryKey: ['storefront-settings'],
        queryFn: getStorefrontSettings,
        staleTime: 1000 * 60 * 60, // 1 hour
        retry: 1,
    });

    const settings = data || {};
    const allowGuestCheckout = Boolean(settings?.checkout?.allow_guest);
    const minOrderTotal = Number(settings?.checkout?.min_order_total) || 0;

    return { settings, allowGuestCheckout, minOrderTotal, isLoading };
};

export default useGetStorefrontSettings;
